export default __webpack_public_path__ + "static/media/1.3c35e088.png";